import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Select from "react-select"
import { useParams } from 'react-router-dom'

import { stringifyDate, useListData } from '../modules'

import Datepicker from '../partials/actions/Datepicker'
import Receive from '../components/resusable/receive'

const ItemTimeline = () => {
    const { id } = useParams()
    const { user } = useSelector(state => state.application)

    const [stores] = useState(user.stores.map(store => ({ ...store, label: store.name, value: store._id })))
    const [store, setStore] = useState(user.stores.length > 0 ? { ...user.stores[0], label: user.stores[0].name, value: user.stores[0]._id } : null)

    const [{ loading, error, fetch }, { list: history, data }, { Paginate, page = 1, limit = 100 }] = useListData('itemHistory', {
        id,
        store: store?._id,
    }, { notify: true }, 'history')

    const selectStore = val => {
        setStore(val)
        fetch()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <ul />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <Datepicker />
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Item History</h2>
                    <Select
                        value={store}
                        onChange={selectStore}
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={stores}
                        placeholder="Select Store" />
                </header>

                <Receive
                    error={error}
                    loading={loading}
                    progress>
                    <div className="relative w-1/2 m-8">
                        <div className="border-r-2 border-gray-200 border-dotted absolute h-full top-0 z-0" style={{ left: 7 }} />
                        <ul className="list-none m-0 p-0">
                            {
                                history.map(record =>
                                    <li className="mb-2">
                                        <div className="flex items-center mb-1">
                                            <div className={`${record.bulkCount * record.containing > 0 ? 'bg-green-500' : 'bg-red-500'} rounded-full h-4 w-4 border-gray-200 border-2 z-10`}>
                                            </div>
                                            <div className="flex-1 ml-4 font-medium">{stringifyDate(record.committedOn)}</div>
                                        </div>
                                        <div className="ml-12">
                                            <p className={`${record.bulkCount * record.containing > 0 ? 'text-green-600' : 'text-red-500'} mb-1 mt-0 text-md`}>{record.bulkCount * record.containing} {data?.item?.issuedIn}</p>
                                            <p className="text-gray-500 text-xs italic">New Total: {record.total} {data?.item?.issuedIn} { record.total > 0 && record.desc.includes('Purchase') && `@ Ksh. ${record.bp}` }</p>
                                            {record.desc}
                                            <p className="text-gray-500 mt-2 text-xs italic">Recorded by {record.committedBy.name}</p>
                                        </div>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </Receive>
            </div>
        </div>
    )
}

export default ItemTimeline